
// The following settings need changing depending on what environment you are in
export const isMobile: boolean = false
export const isLocal: boolean = false
export const isLive:boolean = true
export const versionNumber : string = '1.4.0'

// You should not need to change the following settings

export const rootApiUrl: string = 
  isLocal ? 'https://localhost:7128/'
  : isLive ?  'https://partyplannerapi.abs.uk.com/'
  : 'https://devppapi.abs.uk.com/'

  export const rootUrl: string = 
  isLive ?  'https://partyplanner.abs.uk.com/'
  : 'https://devpp.abs.uk.com/'

export const authSettings = {
   domain: isLocal ? 'ciclistapazzo.eu.auth0.com' : 'login.abs.uk.com',
    client_id: 'GH3kUE031ffTEiBEBGgjNdXWPvEgKfZD',
    redirect_uri: window.location.origin + '/',
    scope: 'openid profile email offline_access',
    audience: 'http://devpp',
    useRefreshTokens: isMobile ? true : false,
    useRefreshTokensFallback: true
  }

  const appId = "com.uk.abs.partyplanner"
  export const callbackUri = isMobile
  ? `${appId}://${authSettings.domain}/capacitor/${appId}/callback`
  : window.location.origin;